import React from 'react'
import styled from 'styled-components'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import PropTypes from 'prop-types'
import ShareAndEarnButton from '../ShareButton'
import { Link } from 'react-router-dom'

const BreadcrumbContainer = styled.div`
  .breadcrumb-item + .breadcrumb-item::before {
    content: '>';
  }
`
const Item = styled.li`
  padding: 0;
  margin: 0.25em;
`
const LinkDashboard = styled(Link)`
  color: #65d28e;
`
export default function Breadcrumb(props) {
  const { pageTitle } = props
  return (
    <Row className="mt-2 d-none d-md-flex d-lg-flex">
      <Col>
        <BreadcrumbContainer>
          <ul className="list-unstyled list-inline">
            <Item className="breadcrumb-item list-inline-item">
              <LinkDashboard to="/dashboard">Dashboard</LinkDashboard>
            </Item>
            <Item className="breadcrumb-item active list-inline-item">
              <span>{pageTitle}</span>
            </Item>
          </ul>
        </BreadcrumbContainer>
      </Col>
      {/*<Col>*/}
      {/*  <ShareAndEarnButton />*/}
      {/*</Col>*/}
    </Row>
  )
}

Breadcrumb.propTypes = {
  pageTitle: PropTypes.string,
}
